import IWORequestService from "../service/IWORequestService";

export const IWORequestAction = (postData) => async (dispatch) => {
  dispatch({ type: "FETCH_IWO_REQUEST" });

  try {
    console.log("Sending POST to:", "NewIWORequest", postData);
    console.log("QrJobService baseURL:", IWORequestService.defaults.baseURL);


    const response = await IWORequestService.post("NewIWORequest", postData);

    console.log("IWO API RESPONSE:", response.data);

    dispatch({
      type: "FETCH_IWO_SUCCESS",
      payload: response.data,
    });
  } catch (error) {
    console.error("QR API ERROR:", error.response || error.message);
    dispatch({
      type: "FETCH_IWO_FAILURE",
      error: error.message,
    });
  }
};